import { QuickModule } from "@uderly/react-uderly-ui";
// import React, { useState, useContext, useEffect, ReactNode, useImperativeHandle } from 'react';
// import { AxiosResponse } from 'axios';
// import {
//   DataGrid,
//   DataGridProps,
//   GridColDef,
//   GridRowParams,
// } from '@mui/x-data-grid';
// import IconButton from '@mui/material/IconButton';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
// import AddIcon from '@mui/icons-material/Add';
// import DeleteIcon from '@mui/icons-material/Delete';
// import Tooltip from '@mui/material/Tooltip';
// import { useTranslation } from 'react-i18next';
// import { Formik, FormikErrors, FormikProps } from 'formik';
// import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

// import { LayoutContext, ILayoutContext, DialogModesEnum, WrapFormView, DataLoader } from "@uderly/react-uderly-ui";
// import { createItemRequest, getItemRequest, deleteItemRequest, updateItemRequest } from "@uderly/react-uderly-ui";
// import { IndexedRow, ModuleHandle, Role } from "@uderly/react-uderly-ui";

// export interface ManageRolePermissions {
//   role: Role;
//   prefix: string;
// }

// export interface QuickModuleProps {
//   title?: string;
//   noItemsMessage?: ReactNode;
//   initialValues?: any;
//   dataGridProps?: DataGridProps;
//   className?: string;
//   columns: GridColDef<any>[];
//   records: readonly any[];
//   baseApi?: string;
//   schema?: any | (() => any);
//   checkboxSelection?: boolean;
//   selectionOnClick?: boolean;
//   view?: ((item: any) => ReactNode) | ((item: any, props: FormikProps<any>) => ReactNode) | ((props: FormikProps<any>) => ReactNode);
//   enableDelete?: boolean;
//   disableView?: boolean;
//   disableEdit?: boolean;
//   disableInsert?: boolean;
//   checkCanEdit?: (row: IndexedRow) => boolean;
//   getRowClassName?: (row: IndexedRow) => string;
//   onSubmit?: ((item: any) => Promise<AxiosResponse<IndexedRow>>) | ((item: any) => AxiosResponse<IndexedRow>) | ((item: any) => void);
//   onSubmitted?: (item: any, newRecords: any[]) => Promise<void> | void;
//   onDelete?: (item: any) => Promise<void> | void;
//   onDeleted?: (item: any, newRecords: any[]) => Promise<void> | void;
//   onReordered?: (source: any, dest: any) => Promise<void> | void;
//   onSelected?: (item: any) => Promise<void> | void;
//   rowHeight?: number;
//   reorderable?: boolean;
//   closeOnCreation?: boolean;
//   manageRolePermissions?: ManageRolePermissions;
//   initialFilters?: any;
//   filtersForm?: ({ values }: FormikProps<any>) => JSX.Element | undefined;
//   onFiltersChanged?: ((values: unknown) => void | object | Promise<FormikErrors<unknown>>) & ((values: unknown) => Promise<void>);
//   topOptions?: React.ReactNode;
// }

// export const StrictModeDroppable = ({ children, ...props }: any) => {
//   const [enabled, setEnabled] = useState(false);

//   useEffect(() => {
//     const animation = requestAnimationFrame(() => setEnabled(true));

//     return () => {
//       cancelAnimationFrame(animation);
//       setEnabled(false);
//     };
//   }, []);

//   if (!enabled) {
//     return null;
//   }

//   return <Droppable {...props}>{children}</Droppable>;
// };

// const QuickModule = React.forwardRef<ModuleHandle, QuickModuleProps>((props, ref) => {
//   const { t } = useTranslation();

//   const { className } = props;

//   const layoutContext = useContext(LayoutContext) as ILayoutContext;

//   const { records, columns, view, checkboxSelection, selectionOnClick, schema, initialValues,
//     enableDelete, disableView, disableEdit, disableInsert, checkCanEdit, getRowClassName, rowHeight, reorderable, closeOnCreation, manageRolePermissions } = props;

//   const [sColumns, setColumns] = useState(columns);
//   const [sRecords, setRecords] = useState([] as readonly any[]);
//   const [modal, setModal] = useState<ReactNode>();
//   const [overlay, setOverlay] = useState<ReactNode>();
//   const [currentItem, setCurrentItem] = useState<IndexedRow | undefined>();
//   const [filters, setFilters] = useState(props.initialFilters ?? {});

//   const canDelete = !manageRolePermissions || (manageRolePermissions.role.permissions
//     && manageRolePermissions.role.permissions.filter(p => p.title === (manageRolePermissions.prefix + "delete")).length > 0);

//   const canEdit = !disableEdit && (!manageRolePermissions || (manageRolePermissions.role.permissions
//     && manageRolePermissions.role.permissions.filter(p => p.title === (manageRolePermissions.prefix + "edit")).length > 0));

//   const canCreate = !manageRolePermissions || (manageRolePermissions.role.permissions
//     && manageRolePermissions.role.permissions.filter(p => p.title === (manageRolePermissions.prefix + "create")).length > 0);

//   const debounceTimespanMs = 500;

//   let timeoutRef: number | undefined | NodeJS.Timeout;

//   useImperativeHandle(ref, () => ({
//     updateRecord: updateRecord,
//     createItem: undefined,
//     fetchItem: undefined,
//     updateItem: undefined,
//     setItem: undefined,
//     getRecords: () => records as [],
//     onInsert: onInsert,
//     onEdit: fetchAndDisplayItem,
//   }));

//   const updateRecord = (row: IndexedRow) => {
//     if (row && row.id >= 0 && records) {
//       const i = records.findIndex((item) => item.id === row.id);

//       console.log("UPDATE " + i);

//       if (i >= 0) {
//         const updatedRecords = [...records];
//         updatedRecords[i] = row;
//         setRecords(updatedRecords);
//       }
//     }
//   };

//   const defaultDelete = async (item: any) => {
//     const url = props.baseApi + '/' + item.id;
//     const response = await deleteItemRequest(url);

//     if (response && response.status === 204) {
//       const newRecords = records.filter(r => r.id !== item.id);
//       setRecords(newRecords);

//       if (props.onDeleted)
//         props.onDeleted(item, newRecords);
//     }
//   }

//   const confirmDelete = (item: any) => {
//     const onDelete = async () => {
//       console.log('User has confirmed to delete the item ' + item);

//       if (props.onDelete)
//         await props.onDelete(item);
//       else
//         await defaultDelete(item);
//     };

//     layoutContext.dialog.show({
//       title: t('delete-confirmation'),
//       content: t('delete-confirmation-desc'),
//       mode: DialogModesEnum.confirmation,
//       onConfirm: onDelete
//     });
//   };

//   const RowMenu = (props: any) => (
//     !canDelete ? <></> :
//       <IconButton aria-label="delete" onClick={(e) => { e.stopPropagation(); confirmDelete(props.row); }}>
//         <DeleteIcon />
//       </IconButton>);

//   useEffect(() => {
//     if (checkboxSelection && selectionOnClick)
//       throw new Error("Both checkbox and row selection have been enabled and it is not supported by QuickModule.");

//     setRecords(records);

//     const cols = enableDelete ? [
//       ...columns,
//       {
//         field: 'actions',
//         headerName: '',
//         sortable: false,
//         filterable: false,
//         minWidth: 30,
//         renderCell: (params: any) => <RowMenu row={params.row} />
//       }
//     ] : columns;

//     for (const col of cols)
//       if ((col as GridColDef).disableReorder === undefined)
//         (col as GridColDef).disableReorder = true;

//     setColumns(cols);
//   }, [setColumns, setRecords, checkboxSelection, columns, enableDelete, props.records, records, selectionOnClick]);

//   const defaultSubmit = async (item: IndexedRow) => {
//     let response: null | AxiosResponse<any> = null;

//     if (props.baseApi) {
//       let newRecords: any[] | null = null;

//       if (item.id) {
//         const url = props.baseApi + '/' + item.id;

//         response = (await updateItemRequest(url, item, {
//           headers: {
//             'Accept-Language': 'en-GB'
//           }
//         })) as AxiosResponse<any>;

//         if (response.status === 202 || response.status === 200) {
//           const { data } = response.data; // Updated Item
//           const itemIndex = records.findIndex(r => r.id === data.id);

//           if (itemIndex >= 0) {
//             newRecords = [...sRecords];
//             newRecords[itemIndex] = data;

//             setRecords(newRecords);
//           }
//         }
//       } else {
//         const url = props.baseApi;

//         response = (await createItemRequest(url, item, {
//           headers: {
//             'Accept-Language': 'en-GB'
//           }
//         })) as AxiosResponse<any>;

//         if (response.status === 201 || response.status === 200) {
//           newRecords = [...records, response.data.data];
//           setRecords(newRecords);
//         }
//       }

//       if (props.onSubmitted)
//         await props.onSubmitted(item, newRecords as any[]);
//     }

//     return response;
//   }

//   const onSubmit = async (item: IndexedRow) => {
//     // if (item?.id != null && disableEdit)
//     //   return null;

//     const response = props.onSubmit ? await props.onSubmit(item) : await defaultSubmit(item);

//     if (response) {
//       await fetchAndDisplayItem(response.data.data);
//     } else {
//       console.error(response);
//       setModal(null);
//     }

//     if (closeOnCreation || disableView)
//       setModal(null);

//     layoutContext.dialog.hide();
//   }

//   const fetchAndDisplayItem = async (row: IndexedRow) => {
//     setOverlay(<DataLoader overlay fullscreen />);

//     let itemToDisplay = row;

//     if (props.baseApi) {
//       const response = await getItemRequest(props.baseApi + "/" + row.id);

//       if (response && response.status === 200) {
//         const { data } = response.data;

//         itemToDisplay = data;
//       }
//     }

//     setCurrentItem(itemToDisplay);

//     setOverlay(undefined);

//     setModal(<WrapFormView
//       item={itemToDisplay}
//       hideHeader
//       view={view as (((item: any) => ReactNode) | ((item: any, props: FormikProps<any>) => ReactNode))}
//       schema={schema}
//       onSubmit={onSubmit}
//       disableCreate={!canCreate}
//       disableUpdate={!canEdit || !(!checkCanEdit || checkCanEdit(row))}
//       disableDelete={!canDelete} />);
//   }

//   const onRowClick = async (e: GridRowParams) => {
//     const { row } = e;

//     if (!(selectionOnClick || disableView)) {
//       fetchAndDisplayItem(row);
//     }

//     if (props.onSelected)
//       await props.onSelected(row);
//   };

//   const onInsert = (_event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
//     setCurrentItem(initialValues);
//     setModal(<WrapFormView
//       hideHeader
//       item={initialValues}
//       view={view as (((item: any) => ReactNode) | ((item: any, props: FormikProps<any>) => ReactNode))}
//       schema={schema}
//       onSubmit={onSubmit} />);
//   };

//   const onDragEnd = async (result: any) => {
//     // dropped outside the list
//     if (!result.destination) {
//       return;
//     }

//     const items = reorder(
//       sRecords as [],
//       result.source.index,
//       result.destination.index
//     );

//     setRecords(items);

//     if (props.onReordered)
//       await props.onReordered(sRecords[result.source.index], sRecords[result.destination.index]);
//   }

//   const reorder = (list: [], startIndex: number, endIndex: number) => {
//     const result = Array.from(list);
//     const [removed] = result.splice(startIndex, 1);
//     result.splice(endIndex, 0, removed as never);

//     return result;
//   };

//   const onFiltersChanged = async (values: any) => {
//     setFilters(values);

//     if (props.onFiltersChanged)
//       props.onFiltersChanged(values);
//   };

//   return (
//     <div className={`quick-module ${className ?? ''}`}>
//       {props.title && <h1>{props.title}</h1>}

//       {props.filtersForm && sRecords/* && sRecords.length > 0*/ &&
//         <div className="filters">
//           <Formik
//             onSubmit={(values) => { console.log(values); }}
//             initialValues={props.initialFilters}
//             validateOnChange={true}
//             validate={(values: any) => {
//               if (onFiltersChanged && JSON.stringify(filters) !== JSON.stringify(values)) {
//                 if (timeoutRef)
//                   clearTimeout(timeoutRef);

//                 timeoutRef = setTimeout(async () => {
//                   await onFiltersChanged(values);
//                   setFilters(values);
//                   timeoutRef = -1;
//                 }, debounceTimespanMs);
//               }
//             }}>
//             {props.filtersForm}
//           </Formik>
//         </div>}

//       {props.topOptions && <div className='top-options'>
//         {props.topOptions}
//       </div>}

//       {/* Reorderable datagrid */}
//       {reorderable && canEdit && sRecords && sRecords.length > 0 &&
//         <DragDropContext onDragEnd={onDragEnd}>
//           <StrictModeDroppable droppableId="droppable">
//             {(provided, snapshot) => (
//               <table className={`datagrid ${snapshot.isDraggingOver ? 'is-dragging' : ''}`}>
//                 <tbody
//                   {...provided.droppableProps}
//                   ref={provided.innerRef}>
//                   {sRecords.map((item, index) => (
//                     <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
//                       {(provided, snapshot) => (
//                         <tr
//                           onClick={() => {
//                             if (!selectionOnClick && !disableView) fetchAndDisplayItem(item);
//                             if (onRowClick) onRowClick({ id: item.id, columns: sColumns, row: item })
//                           }}
//                           ref={provided.innerRef}
//                           {...provided.draggableProps}
//                           {...provided.dragHandleProps}
//                           className={`draggable ${snapshot.isDragging ? "is-dragging" : ""} ${getRowClassName ? getRowClassName(item) : ''}`}
//                           style={provided.draggableProps.style}>
//                           {sColumns.map(col =>
//                             <td
//                               key={`qm-item-${col.field}-${item.id}`}
//                               style={{ flex: col.flex, minWidth: col.minWidth, width: col.width }}
//                               className={col.cellClassName as string ?? ''}>
//                               {col.renderCell ? col.renderCell({ row: item, index } as any) : item[col.field]}</td>)}
//                         </tr>
//                       )}
//                     </Draggable>
//                   ))}
//                   {provided.placeholder}
//                 </tbody>
//               </table>
//             )}
//           </StrictModeDroppable>
//         </DragDropContext>
//       }

//       {/* Not reorderable datagrid */}
//       {(!reorderable || !canEdit) && sRecords && sRecords.length > 0 &&
//         <DataGrid
//           rows={sRecords}
//           columns={sColumns}
//           disableColumnFilter
//           checkboxSelection={checkboxSelection}
//           rowHeight={rowHeight}
//           onRowClick={onRowClick}
//           getRowClassName={(params) => getRowClassName ? getRowClassName(params.row) : ''}
//           {...props.dataGridProps} />}

//       {sRecords && sRecords.length === 0 &&
//         <div className="no-items">
//           {props.noItemsMessage ?? <p>{t('no-items')}</p>}
//           {/* <p>{t('create-new-item', { item: props.title })}</p> */}
//         </div>}

//       {(view && !disableInsert && canCreate) &&
//         <div className="records-view-actions">
//           <Tooltip title={t("add-new")}>
//             <IconButton size="small" aria-label="delete" onClick={onInsert}>
//               <AddIcon />
//             </IconButton>
//           </Tooltip>
//         </div>}

//       {modal &&
//         <div className="quick-module-view-container">
//           <div className="quick-module-view">
//             <div className="quick-module-header">
//               <IconButton size="small" onClick={() => setModal(null)}>
//                 <ChevronLeftIcon />
//               </IconButton>

//               {currentItem && currentItem.id &&
//                 <p className="item-id">ID: {currentItem.id}</p>}
//             </div>

//             <div className="quick-module-content">
//               {modal}
//               {overlay}
//             </div>
//           </div>
//         </div>}
//     </div>);
// });

export default QuickModule;